import * as React from 'react'

import { Box, ColumnSplit, Line, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { Props } from 'modules/app_store/pages/SettingsPage/Apps/common/types'

import Content from './Content'

const ExpensesSettings = ({ subscriptionAddon: addon }: Props) => {
  return (
    <ColumnSplit>
      <Box>
        <Box paddingBottom="s8">
          <Text.Header1>{i18n.t('expenses.settings.title')}</Text.Header1>
        </Box>
        <Text.Normal>{i18n.t('expenses.settings.description')}</Text.Normal>
        <Line />
      </Box>
      <Content addon={addon} />
    </ColumnSplit>
  )
}

export default ExpensesSettings
